module.exports = __webpack_public_path__ + "static/media/talent-feature-interview-reschedule@3x.fa08b980.png";